import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAdblockComponent } from './simple-icons-adblock.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAdblockComponent ],
    exports:      [ SimpleIconsAdblockComponent ],
    bootstrap:    []
})
export class SimpleIconsAdblockModule {}
